import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { About } from "./pages/About";
import { DreamHome } from "./pages/DreamHome";
import { Home } from "./pages/Home";
import { MlsListings } from "./pages/MlsListings";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsOfUse } from "./pages/TermsOfUse";
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rkno0jqitmui">
      <Routes data-id="element-1" data-mp="2rk45p1wykwfy">
        <Route path="/" element={<Home data-id="element-3" data-mp="2rl6t2zv2ogr4" />} data-id="element-2" data-mp="2rlynw8guiagc" />
        <Route path="/about" element={<About data-id="element-5" data-mp="2mmcd05ohp6ap" />} data-id="element-4" data-mp="2rikmp3jx47ah" />
        <Route path="/dream-home" element={<DreamHome data-id="element-7" data-mp="2mjpvpebsrcfa" />} data-id="element-6" data-mp="2mmvkesgikcah" />
        <Route path="/mls-listings" element={<MlsListings data-id="element-9" data-mp="31bs0ncsq4vm6" />} data-id="element-8" data-mp="31aqhel1k12td" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-11" data-mp="2wka20ve6b74d" />} data-id="element-10" data-mp="31c1ha9rvpqf7" />
        <Route path="/terms-of-use" element={<TermsOfUse data-id="element-13" data-mp="2wip2ssgwz006" />} data-id="element-12" data-mp="2wiyx2s8zrtbo" />
      </Routes>
    </BrowserRouter>;
}